import '@amzn/meridian-tokens/base/font/amazon-ember.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import 'react-loading-skeleton/dist/skeleton.css';

import AppLayout from '@amzn/meridian/app-layout';
import Box from '@amzn/meridian/box';
import Responsive from '@amzn/meridian/responsive';
import useGetStoreDetailsQuery from '@amzn/rangoli-seller-desktop-fe-auth-utils/src/auth/useGetStoreDetailsQuery';
import {
  findCurrentShop,
  useLoginUserMutation,
} from '@amzn/rangoli-seller-desktop-fe-auth-utils/src/index';
import { getPlatformCookie } from '@amzn/rangoli-seller-desktop-fe-auth-utils/src/index';
import { useGetShopSelectionMutation } from '@amzn/rangoli-seller-desktop-fe-auth-utils/src/index';
import {
  commonUnityStore,
  CustomToaster,
  FeatureFlags,
  getShopId,
  MixPanel,
  MixPanelEventName,
} from '@amzn/rangoli-seller-desktop-utils/src/index';
import { css } from '@emotion/css';
import Cookies from 'js-cookie';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { zendeskchatScript } from './api/ApiClient';
import HelpAndSupport from './components/helpAndSupport/HelpAndSupport';
import MainHeader from './components/MainHeader/MainHeader';
import MainHeaderMobile from './components/MainHeader/MainHeaderMobile';
import PreLoginLandingPage from './components/preLoginComponent/PreLoginLandingPage';
import Sidebar from './components/Sidebar/Sidebar';
import { ENV_STAGES } from './constants/apiConstants';
import { errorTypes } from './constants/errors';
import { HeaderType } from './constants/mainHeaderConstant';
import { userAuthStore } from './store/UserAuthStore';
import { mainStyle } from './Style/Style';
import { ScreenSize } from './types/ScreenSize';
import useGetChatBotJWTQuery from './api/ChatbotJWT';
import { sidebarStore } from './store/SidebarStore';
import { getFeatureFlagStatus } from '@amzn/rangoli-seller-desktop-utils/src/index';
import 'react-loading-skeleton/dist/skeleton.css';
import { appendRefMarkers } from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/index';
import BusinessDetailsModal from './components/BusinessDetails/BusinessDetailsModal';
import useGetBusinessDetails from './api/getBusinessDetails';
import SuccessModal from './components/SuccessModal/SuccessModal';
import {
  getRefMarker,
  REF_MARKER_KEY,
} from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/utils/RefMarkersConfig';

const {
  UAM_ENABLED_STATUS,
  SEO_ENABLED_STATUS,
  CUSTOMER_SEGMENTS_ENABLED_STATUS,
  MA_ENABLED_STATUS,
  REVIEWS_ENABLED_STATUS,
} = FeatureFlags;

declare global {
  interface Window {
    zE: any;
  }
}

const { PRIMARY_HEADER, SECONDARY_HEADER } = HeaderType;

function App(props): JSX.Element {
  const positionRelative = css({
    position: 'relative',
  });
  const { store } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const shopSelectionMutation = useGetShopSelectionMutation();
  const { isGetShopLoader, handleIsGetShopLoader } = userAuthStore;
  const [isShowOnBoardingPage, setIsShowOnBoardingPage] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(true);
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const loginUserMutation = useLoginUserMutation();
  const params = new URLSearchParams(location.search);
  const isStoreOnboarded = params.get('storeOnboarded');
  const showStoreOnboarding = () => localStorage.getItem('isStoreOnboarded');
  const [showBusinessDetailsModal, setShowBusinessDetailsModal] = useState(false);
  const {
    data: storeDetails,
    isLoading: storeDetailsLoader,
    refetch: refetchStoreDetails,
  } = useGetStoreDetailsQuery(true);
  const { data: jwtToken, refetch: refetchJWTToken } = useGetChatBotJWTQuery();
  const { handleCurrentStoreDetails, handleAllStoreDetails } = userAuthStore;
  const [showHeader, setShowHeader] = useState<boolean>(true);
  const { refetch: fetchBusinessDetails } = useGetBusinessDetails();

  const urlParams = new URLSearchParams(window.location.search);

  const spapiOauthCode = urlParams.get("spapi_oauth_code")?.length > 0;
  const sellingPartnerId = urlParams.get("selling_partner_id")?.length > 0;

  if(spapiOauthCode && sellingPartnerId) {
    sessionStorage.setItem("spapiOauthCode", urlParams.get("spapi_oauth_code"));
    sessionStorage.setItem("sellingPartnerId", urlParams.get("selling_partner_id"));
  }


  const verifyBusinessProfileCompletion = async () => {
    const data = await fetchBusinessDetails();
    const isBusinessProfileIncomplete =
      data?.data?.responseStatus === 'NOT_RESPONDED' && data?.data?.questions?.length > 0;
    if (isBusinessProfileIncomplete) {
      setShowBusinessDetailsModal(true);
    } else {
      setShowBusinessDetailsModal(false);
    }
  };

  const navigateToMFE = (e: Event) => {
    const path = (e as CustomEvent).detail;
    navigate(path?.key);
  };

  useEffect(() => {
    if (storeDetails?.data) {
      handleAllStoreDetails(storeDetails?.data);
      const storeDetailsList = storeDetails?.data;
      const currentStore = findCurrentShop(storeDetailsList);
      if (currentStore) {
        handleCurrentStoreDetails(currentStore);
      }
    }
  }, [storeDetails?.data]);

  useEffect((): void => {
    //header will be hidden in case of the editor
    window.addEventListener('HIDE_SIDE_BAR', (e: Event) => {
      const detail = (e as CustomEvent).detail;
      setShowHeader(!detail.hideSideBar);
    });
  });

  const handleChatScript = async () => {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.src = `${zendeskchatScript}`;
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      window.zE('messenger', 'loginUser', function (callback) {
        callback(jwtToken?.authToken);
      });
    };
  };

  const authUser = async () => {
    if (window.location.hostname === ENV_STAGES.PROD) {
      Cookies.remove('x-acbin', { domain: '.amazon.in' });
      Cookies.remove('ubid-acbin', { domain: '.amazon.in' });
      Cookies.remove('posSessionId', { domain: '.amazon.in' });
      Cookies.remove('userId', { domain: '.amazon.in' });
    } else {
      Cookies.remove('x-tacbin', { domain: '.amazon.com' });
      Cookies.remove('ubid-tacbin', { domain: '.amazon.com' });
      Cookies.remove('posSessionId', { domain: '.amazon.com' });
      Cookies.remove('userId', { domain: '.amazon.in' });
    }
    localStorage.clear();
    await loginUserMutation
      .mutateAsync()
      .then((response) => {
        window.location.replace(response?.redirectUrl);
      })
      .catch(() => {
        setError(true);
      });
  };

  useEffect(() => {
    if (jwtToken?.authToken && !document.getElementById('ze-snippet')) {
      handleChatScript();
    }
  }, [jwtToken?.authToken]);

  const loadInitialDetails = async (): Promise<void> => {
    await getShopDetails();
    userAuthStore.isLogged();
    setIsLoggedIn(true);
    refetchStoreDetails();
    refetchJWTToken();
    handleUserManagementFeatureFlagStatus();
    fetchSEOFeatureFlagStatus();
    fetchCustomerSegmentsFlagStatus();
    fetchMAFeatureFlagStatus();
    fetchReviewsFeatureFlagStatus();
  };

  useEffect(() => {
    MixPanel.track(MixPanelEventName.HOME_URL_VISIT, { [REF_MARKER_KEY]: getRefMarker() });
    window.addEventListener('CHANGE_PATH', navigateToMFE);
    if (isStoreOnboarded) {
      localStorage.setItem('isStoreOnboarded', 'true');
    }
    getPlatformCookie();
    if (localStorage.getItem('x-tacbin')) {
      if (localStorage.getItem('isUserLoggedInEventTracked') === null) {
        MixPanel.track(MixPanelEventName.LOGIN, { [REF_MARKER_KEY]: getRefMarker() });
        localStorage.setItem('isUserLoggedInEventTracked', 'true');
      }
      loadInitialDetails();
    } else {
      MixPanel.track(MixPanelEventName.AUTH_PAGE_VISIT, { [REF_MARKER_KEY]: getRefMarker() });
      authUser();
    }
    return () => {
      window.removeEventListener('CHANGE_PATH', navigateToMFE);
    };
  }, []);

  const handleCloseSuccessModal = () => {
    window.history.replaceState({}, '', window.location.pathname);
    setShowModal(false);
    localStorage.removeItem('isStoreOnboarded');
  };
  // This function can be a global one as it called in multple placed, need to be handled different
  const getShopDetails = async () => {
    handleIsGetShopLoader(true);
    await shopSelectionMutation
      .mutateAsync()
      .then((response) => {
        verifyBusinessProfileCompletion();
        handleIsGetShopLoader(false);
        userAuthStore.shopSelectionResponse = response;
        MixPanel.track(MixPanelEventName.VALID_TOKEN, { [REF_MARKER_KEY]: getRefMarker() });
      })
      .catch((error) => {
        if (
          error?.response?.data?.error === errorTypes.userNotRegistered ||
          error?.response?.data?.errorCode === errorTypes.notFound
        ) {
          setIsShowOnBoardingPage(true);
          if (localStorage.getItem('isSignUpEventTracked') === null) {
            MixPanel.track('signup');
            localStorage.setItem('isSignUpEventTracked', 'true');
          }
          {(!spapiOauthCode || !sellingPartnerId) && navigate(appendRefMarkers('/store-onboarding'));}
          handleIsGetShopLoader(false);
        } else if (error?.response?.data?.error === errorTypes.tokenExpired) {
          localStorage.clear();
          authUser();
          handleIsGetShopLoader(false);
        } else if (error?.code === errorTypes.networkError) {
          handleIsGetShopLoader(false);
        } else {
          handleIsGetShopLoader(false);
          authUser();
        }
      });
  };

  const handleUserManagementFeatureFlagStatus = async () => {
    const shopId = await getShopId();
    sidebarStore.setIsUserManagementEnabled(
      await getFeatureFlagStatus(
        UAM_ENABLED_STATUS.flagName,
        UAM_ENABLED_STATUS.defaultValue,
        shopId
      )
    );
  };

  const fetchSEOFeatureFlagStatus = async (): Promise<void> => {
    const shopId = await getShopId();
    const isSEOFeatureFlagStatus: boolean = await getFeatureFlagStatus(
      SEO_ENABLED_STATUS.flagName,
      SEO_ENABLED_STATUS.defaultValue,
      shopId
    );
    commonUnityStore.setIsSEOFeatureEnabled(isSEOFeatureFlagStatus);
  };

  const fetchCustomerSegmentsFlagStatus = async (): Promise<void> => {
    const shopId = await getShopId();
    const isCustomerSegmentsFlagStatus: boolean = await getFeatureFlagStatus(
      CUSTOMER_SEGMENTS_ENABLED_STATUS.flagName,
      CUSTOMER_SEGMENTS_ENABLED_STATUS.defaultValue,
      shopId
    );
    sidebarStore.setIsCustomerSegmentsEnabled(isCustomerSegmentsFlagStatus);
  };

  const fetchMAFeatureFlagStatus = async (): Promise<void> => {
    const shopId = await getShopId();
    const isMAFeatureFlagStatus: boolean = await getFeatureFlagStatus(
      MA_ENABLED_STATUS.flagName,
      MA_ENABLED_STATUS.defaultValue,
      shopId
    );
    commonUnityStore.setIsMAFeatureEnabled(isMAFeatureFlagStatus);
  };

  const fetchReviewsFeatureFlagStatus = async (): Promise<void> => {
    const shopId = await getShopId();
    const isReviewsFeatureFlagStatus: boolean = await getFeatureFlagStatus(
      REVIEWS_ENABLED_STATUS.flagName,
      REVIEWS_ENABLED_STATUS.defaultValue,
      shopId
    );
    sidebarStore.setIsReviewsEnabled(isReviewsFeatureFlagStatus);
  };

  const showOnboardingPage = isShowOnBoardingPage || spapiOauthCode || sellingPartnerId;

  return (
    <>
      {showStoreOnboarding() && showModal && (
        <SuccessModal
          handleClose={handleCloseSuccessModal}
          showModal={showModal}
          heading={'Congratulations'}
          description={'Your online store is successfully created'}
        />
      )}
      <ToastContainer />
      {isLoggedIn && !isGetShopLoader ? (
        <Responsive
          query="max-width"
          props={{
            showMobileView: {
              default: false,
              [ScreenSize._720]: true,
            },
          }}
        >
          {({ showMobileView }) => (
            <>
              <AppLayout
                mainClassName={mainStyle}
                headerComponent={
                  (showOnboardingPage) ? null : showMobileView ? MainHeaderMobile : MainHeader
                }
                sidebarComponent={showOnboardingPage ? null : showMobileView ? null : Sidebar}
              >
                {showOnboardingPage ? null : !showMobileView &&
                  !showOnboardingPage &&
                  showHeader ? (
                  <MainHeader
                    mode={showOnboardingPage ? SECONDARY_HEADER : PRIMARY_HEADER}
                    storeDetailsLoader={storeDetailsLoader}
                  />
                ) : null}
                {showOnboardingPage ? null : !showMobileView ? (
                  <Sidebar showMobileView={showMobileView} />
                ) : (
                  <MainHeaderMobile
                    mode={showOnboardingPage ? SECONDARY_HEADER : PRIMARY_HEADER}
                    storeDetailsLoader={storeDetailsLoader}
                  />
                )}
                <Box className={positionRelative} width={'100%'} height={'100%'}>
                  {showBusinessDetailsModal && (
                    <BusinessDetailsModal
                      setShowBusinessDetailsModal={setShowBusinessDetailsModal}
                    />
                  )}
                  <Outlet />
                </Box>
              </AppLayout>
            </>
          )}
        </Responsive>
      ) : (
        <PreLoginLandingPage error={error} />
      )}
      <HelpAndSupport />
      <CustomToaster toasterAlignmentHorizontal="end" />
    </>
  );
}

export default observer(App);
